import classNames from 'classnames'
import { InputHTMLAttributes, ReactNode, forwardRef } from 'react'

import styles from './checkbox.module.css'

export interface LegacyCheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
    label: ReactNode
}

export const Checkbox = forwardRef<HTMLInputElement, LegacyCheckboxProps>(function Checkbox({
    className,
    label,
    ...rest
}, ref) {
    return (
        <label className={ classNames(styles.checkbox, className) }>
            <input
                className={ styles.input }
                ref={ ref }
                type="checkbox"
                { ...rest }
            />
            <span className={ styles.box } aria-hidden="true">
                <svg className={ styles.uncheckedIcon } viewBox="0 0 24 24">
                    <path d="M12 1.5 21.1 6.75v10.5L12 22.5l-9.1-5.25V6.75L12 1.5Z" />
                </svg>
                <svg className={ styles.checkedIcon } viewBox="0 0 24 24">
                    <path d="M12 1.5 21.1 6.75v10.5L12 22.5l-9.1-5.25V6.75L12 1.5Z" />
                    <path d="m8 12.2 2.45 2.45L16.5 8.6" />
                </svg>
            </span>
            <span className={ styles.label }>{ label }</span>
        </label>
    )
})
